<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentApp /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/manager/dashboard/HeaderDash.vue'
import SideMenu from '@/components/manager/dashboard/SideMenu.vue'
import ContentApp from '@/components/manager/dashboard/modules/activity/app/ContentApp.vue'

export default 
{
  name: 'App',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentApp
  }
}
</script>
<style>

</style>